const { object, string, number, array, boolean } = require('yup');

const LineSchema = object({
  width: number().required('Required'), // required
  ratio: number().required('Required'), // required
}).default(undefined);

const LegendSchema = object({
  symbol: string().required('Required'), // required
  area: number().required('Required'), // required
  ratio: number().required('Required'), // required
}).default(undefined);


const LetteringSchema = object({
  name: string().required('Required'), // required
  height: number().required('Required'), // required
  width: number().required('Required'), // required
  stroke: number().required('Required'), // required
  ratio: number().required('Required'), // required
  letterSet: object()
    .noUnknown(false)
    .required('All default letters should be specified')
}).default(undefined);

const MaterialSchema = object().shape({
  _id: string(),
  name: string().required('Field is required'), // required
  decimalPlaces: number()
    .typeError('Must be a number')
    .integer('Must be a whole number')
    .min(0, 'Must be 0 or greater')
    .default(2), // min 0, no max, default 2
  type: string().required('Required'), // required enum['volume', 'weight', 'each']
  discreteHomepageStats: boolean().when('type', {
    is: 'each',
    then: (schema) => schema.default(false),
    otherwise: (schema) => schema.default(undefined),
  }), // default false
  homepageStatistic: string().required(true), // enum['liquidMarking', 'eradication']
  customDescription: boolean(), // default false
  measurement: string().required('Required'), // enum['imperial', 'metric'] see MEASUREMENT_SYSTEM
  lines: array().when('type', {
    is: 'eradication',
    then: schema => schema.of(LineSchema.omit(['ratio'])),
    otherwise: schema => schema.of(LineSchema)
  }),
  legends: array().when('type', {
    is: 'eradication',
    then: schema => schema.of(LegendSchema.omit(['ratio'])),
    otherwise: schema => schema.of(LegendSchema)
  }),
  letterings: array().when('type', {
    is: 'eradication',
    then: schema => schema.of(LetteringSchema.omit(['ratio'])),
    otherwise: schema => schema.of(LetteringSchema)
  }),
  glassBeads: array().when('type', {
    is: 'eradication',
    then: schema => schema.of(
      object()
        .shape({
          beadId: string().required('Required'), // required
          ratio: number().required('Required'), // required
          unitType: string().required('Required'), // required enum['weight/volume', 'weight/area']
        })
        .default(undefined)
    ),
    otherwise: schema => schema.default([])
  })
});

export default MaterialSchema;
